

import Link from 'next/link';
import Company from './Company';
import LINKS from 'utils/constants/links';
import { W185H278 } from 'config/image-sizes';
import QUERY_PARAMS from 'utils/constants/query-params';

const StreamLink = ({
  provider,
  baseUrl
}) => (
  <>
    <a href="https://cinedapt.com?piracy-plus" target="_blank" rel="noreferrer">
      <Company src="https://piracyplus.com/assets/cinedapt-logo.png" alt="Cinedapt" />
    </a>
    <style jsx>{`
      a {
        display: block;
        width: 70px !important;
      }
    `}</style>
  </>
);

export default StreamLink;

/*
      href={{
        pathname: LINKS.PERSON.HREF,
        query: {
          [QUERY_PARAMS.ID]: provider.id,
          [QUERY_PARAMS.PAGE]: 1
        }
      }}>
*/